<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Mietvertrag Management

  section.modal-card-body
    ValidationObserver(ref="form")
      .generic-wrapper
        .container
          .two-column
            .column
            .column
              .form.w640
                h2.title.is-6 E-Mail schreiben
                ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Betreff" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.subject")
                ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="formData.body" :editorOptions="editorOptions")

      
  footer.modal-card-foot
    button.button.is-light(@click="$emit('close')") Abbrechen
    button.button.is-secondary(@click="sendContract()") Speichern ohne Senden
    button.button.is-primary(@click="sendContract('sendEmail')") Senden & Speichern
</template>

<script>
import { DateTime } from 'luxon';

export default {
  props: {
    booking: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        subject: 'Unser Angebot zu Ihrer Anfrage - '+this.booking.rentObject.name,
        body: null
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  computed: {
    bookingStatus() {
      return this.$store.state.bookingStatus.all
    }
  },
  async mounted() {
    this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
    const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
    let contractTemplate = emailTemplates.find(e => e.uuid === 'CONTRACT_BACK_EMAIL');
    const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: contractTemplate, booking: this.fullBooking});
    this.formData.subject = result.template.subject;
    this.formData.body = result.template.body;
  },
  methods: {
    sendContract(sendEmail) {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        const loadingComponent = this.$buefy.loading.open();
        const b = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
        await this.$store.dispatch("contracts/back", {...this.formData, rentObjectBookingId: this.booking.id, contractId: b.parentContractId, sendEmail});
        loadingComponent.close();
        
        this.$emit('refreshInbox');
        if (this.$route.name !== 'BookingCalendar') {
          this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.fullBooking.startDate).toHTTP(), jumpObjectId: this.fullBooking.rentObjectId}});
        }
        const bookingReceivedStatus = this.bookingStatus.find(b => b.uuid === 'STATUS_CONTRACT_RECEIVED');
        this.$emit('updateBookingData', {...this.fullBooking, bookingStatusId: bookingReceivedStatus.id});
        this.$emit('close');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}
</style>